import React, { useState } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  InfoTimeCardAdv,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";
import Activities from "./Modals/Activities";
import {  ExitTypeOptions, SendExitNotificationOptions } from "../../../../../../assets/data/projectData";

const OffboardingDetails = () => {
  const [activityModal, setActivityModal] = useState(false);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      exitType: "",
      noticeDate: "",
      dateOfRelease: "",
      payDate: "",
      sendExitNotificationTo: "",
      exitNotes: "",
    },
    {
      exitType: { type: "select", required: true },
      noticeDate: { type: "datepicker", required: true },
    }
  );

  return (
    <div>
      <div className="flex gap-8 mb-6 ">
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Offboarding ID"
            value="EX2022-20"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Date of Release"
            value="11/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Notice Due"
            value="10/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Exit Type"
            value="Resignation"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Status"
            value="Released"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
      </div>
      <PageHeader
        Section={
          <div className="flex">
            <PageTitle
              title={"EMPLOYEE DETAILS"}
              icon={"detection_and_zone"}
              tag="p"
            />
          </div>
        }
        RightSection={
          <>
            <Button title="Edit" size="sm" icon={"edit_square"} />
          </>
        }
      />
      <Divider className="mt-1"/>
      <div className="mt-6 grid grid-cols-2 max-w-5xl gap-x-8 gap-y-6 mb-6">
        <FormFieldSet
          type="select"
          title={"Exit Type"}
          placeholder="Select Exit Type"
          value={formData.exitType}
          onChange={(value) => handleChange("exitType", value)}
          error={errors.exitType}
          options={ExitTypeOptions}
        />
        <FormFieldSet
          type="datepicker"
          title={"Notice Date"}
          placeholder="Select Notice Date"
          value={formData.noticeDate}
          onChange={(value) => handleChange("noticeDate", value)}
          error={errors.noticeDate}
          showDropdown={false}
        />
        <FormFieldSet
          type="datepicker"
          title={"Date of Release"}
          placeholder="Select Date of Release"
          value={formData.dateOfRelease}
          onChange={(value) => handleChange("dateOfRelease", value)}
          error={errors.dateOfRelease}
          showDropdown={false}
        />
        <FormFieldSet
          type="datepicker"
          title={"Pay Date"}
          placeholder="Enter First Name"
          value={formData.payDate}
          onChange={(value) => handleChange("payDate", value)}
          error={errors.payDate}
          showDropdown={false}
        />
        <FormFieldSet
          type="select"
          title={"Send Exit Notification To"}
          placeholder="Enter First Name"
          value={formData.sendExitNotificationTo}
          onChange={(value) => handleChange("sendExitNotificationTo", value)}
          error={errors.sendExitNotificationTo}
          options={SendExitNotificationOptions}
        />
        <FormFieldSet
          type="textArea"
          title={"Exit Notes"}
          placeholder="Enter First Name"
          value={formData.exitNotes}
          onChange={(value) => handleChange("exitNotes", value)}
          error={errors.exitNotes}
          rows={4}
        />
      </div>
      <p>
        Last updated on 01/12/2022 at 17:41:13 by Richa Sarkar.{" "}
        <span
          className="text-info cursor-pointer body-two"
          onClick={() => setActivityModal(true)}
        >
          View All Activites
        </span>
      </p>
      <Activities
        isOpen={activityModal}
        onClose={() => setActivityModal(false)}
      />
    </div>
  );
};

export default OffboardingDetails;
